"use client";

import type { ReactNode } from "react";
import { SWRConfig } from "swr";

import fetcher from "../libs/fetcher";

interface Props {
  children: ReactNode;
}

export default function SWRProvider({ children }: Props) {
  return (
    <SWRConfig
      value={{
        fetcher,
      }}
    >
      {children}
    </SWRConfig>
  );
}
